module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app mdui-container"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "searchbar mdui-toolbar mdui-color-blue mdui-col-xs-12",
    class: {
      searchbar_active: _vm.isSearch
    }
  }, [_c('div', {
    staticClass: "search_switch",
    class: {
      search_switch_active: _vm.isSearch
    },
    attrs: {
      "mdui-menu": "{target: '#search_engine'}"
    }
  }, [_c('img', {
    class: {
      iconHidden: this.searchEngine != 'google'
    },
    attrs: {
      "src": require("./assets/img/search/Google-icon.svg"),
      "width": "20px",
      "height": "36px"
    }
  }), _vm._v(" "), _c('img', {
    class: {
      iconHidden: this.searchEngine != 'baidu'
    },
    attrs: {
      "src": require("./assets/img/search/Baidu-icon.svg"),
      "width": "20px",
      "height": "36px"
    }
  }), _vm._v(" "), _c('img', {
    class: {
      iconHidden: this.searchEngine != 'bing'
    },
    attrs: {
      "src": require("./assets/img/search/Bing-icon.svg"),
      "width": "20px",
      "height": "36px"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "mdui-menu",
    attrs: {
      "id": "search_engine"
    }
  }, [_c('li', {
    staticClass: "mdui-menu-item",
    on: {
      "click": _vm.useGoogle
    }
  }, [_c('a', {
    staticClass: "mdui-ripple",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Google")])]), _vm._v(" "), _c('li', {
    staticClass: "mdui-menu-item",
    on: {
      "click": _vm.useBing
    }
  }, [_c('a', {
    staticClass: "mdui-ripple",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Bing")])]), _vm._v(" "), _c('li', {
    staticClass: "mdui-menu-item",
    on: {
      "click": _vm.useBaidu
    }
  }, [_c('a', {
    staticClass: "mdui-ripple",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Baidu")])])]), _vm._v(" "), (_vm.searchEngine == 'google') ? _c('form', {
    staticClass: "searchbar_form",
    class: {
      searchbar_form_active: _vm.isSearch
    },
    attrs: {
      "action": "https://www.google.com/search"
    }
  }, [_c('input', {
    staticClass: "mdui-textfield-input searchbar_input",
    class: {
      searchbar_input_active: _vm.isSearch
    },
    attrs: {
      "type": "text",
      "name": "q",
      "autocomplete": "off",
      "placeholder": "Search"
    },
    on: {
      "click": _vm.toSearch
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.searchEngine == 'bing') ? _c('form', {
    staticClass: "searchbar_form",
    class: {
      searchbar_form_active: _vm.isSearch
    },
    attrs: {
      "action": "https://www.bing.com/search"
    }
  }, [_c('input', {
    staticClass: "mdui-textfield-input searchbar_input",
    class: {
      searchbar_input_active: _vm.isSearch
    },
    attrs: {
      "type": "text",
      "name": "q",
      "autocomplete": "off",
      "placeholder": "Search"
    },
    on: {
      "click": _vm.toSearch
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.searchEngine == 'baidu') ? _c('form', {
    staticClass: "searchbar_form",
    class: {
      searchbar_form_active: _vm.isSearch
    },
    attrs: {
      "action": "https://www.baidu.com/s"
    }
  }, [_c('input', {
    staticClass: "mdui-textfield-input searchbar_input",
    class: {
      searchbar_input_active: _vm.isSearch
    },
    attrs: {
      "type": "text",
      "name": "wd",
      "autocomplete": "off",
      "placeholder": "Search"
    },
    on: {
      "click": _vm.toSearch
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "overlay",
    class: {
      overlay_active: _vm.isSearch
    },
    on: {
      "click": _vm.closeSearch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, [_c('div', {
    staticClass: "mdui-card mdui-col-xs-12 mdui-col-md-10 mdui-col-offset-md-1 mdui-col-lg-6 mdui-col-offset-lg-1 mdui-shadow-0 sites-card "
  }, [_c('div', {
    staticClass: "mdui-card-header card-header"
  }, [_vm._v("\n  \t\t\t网站\n  \t\t\t"), _c('div', {
    staticClass: "edit",
    on: {
      "click": _vm.editSites
    }
  }, [_vm._v(_vm._s(_vm.editOrComplete))])]), _vm._v(" "), _c('div', {
    staticClass: "mdui-divider"
  }), _vm._v(" "), _c('ul', {
    staticClass: "mdui-list"
  }, [_vm._l((_vm.sites), function(site, index) {
    return _c('li', {
      staticClass: "site"
    }, [_c('button', {
      staticClass: "remove",
      class: {
        remove_active: _vm.canRemove
      },
      on: {
        "click": function($event) {
          return _vm.removeSite(index)
        }
      }
    }, [_c('i', {
      staticClass: "mdui-icon material-icons"
    }, [_vm._v("close")])]), _vm._v(" "), _c('a', {
      attrs: {
        "href": site.url,
        "target": "_blank"
      }
    }, [_c('div', [_c('img', {
      class: {
        remove_active: _vm.canRemove
      },
      attrs: {
        "src": site.icon,
        "width": "55px",
        "height": "55px"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "site-title"
    }, [_vm._v(_vm._s(site.title))])])])
  }), _vm._v(" "), _c('li', {
    staticClass: "site",
    on: {
      "click": _vm.showAddpanel
    }
  }, [_c('i', {
    staticClass: "mdui-icon material-icons add-site-icon",
    class: {
      iconHidden: _vm.hasAddPanel
    }
  }, [_vm._v("add")]), _vm._v(" "), _c('i', {
    staticClass: "mdui-icon material-icons add-site-icon",
    class: {
      iconHidden: !_vm.hasAddPanel
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "site-title"
  }, [_vm._v("添加")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "new_site mdui-color-blue-grey-50",
    class: {
      new_site_active: _vm.hasAddPanel
    }
  }, [_c('div', {
    staticClass: "new-site-info mdui-textfield mdui-textfield-floating-label"
  }, [_c('label', {
    staticClass: "mdui-textfield-label"
  }, [_vm._v("网站地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSiteurl),
      expression: "newSiteurl"
    }],
    staticClass: "mdui-textfield-input",
    attrs: {
      "type": "url"
    },
    domProps: {
      "value": (_vm.newSiteurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSiteurl = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "new-site-info mdui-textfield mdui-textfield-floating-label"
  }, [_c('label', {
    staticClass: "mdui-textfield-label"
  }, [_vm._v("网站名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSitetitle),
      expression: "newSitetitle"
    }],
    staticClass: "mdui-textfield-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newSitetitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSitetitle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "new-site-info mdui-textfield mdui-textfield-floating-label"
  }, [_c('label', {
    staticClass: "mdui-textfield-label"
  }, [_vm._v("网站图标地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSiteicon),
      expression: "newSiteicon"
    }],
    staticClass: "mdui-textfield-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newSiteicon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSiteicon = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "addtodo_button mdui-btn mdui-btn-raised mdui-color-theme-accent mdui-ripple",
    on: {
      "click": _vm.addSite
    }
  }, [_vm._v("添加")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdui-card mdui-col-xs-12 mdui-col-md-5 mdui-col-offset-md-1 mdui-col-lg-3 mdui-shadow-0 todos-card"
  }, [_c('div', {
    staticClass: "mdui-card-header card-header"
  }, [_vm._v("\n  \t\t\t待办事项\n  \t\t")]), _vm._v(" "), _c('div', {
    staticClass: "mdui-divider"
  }), _vm._v(" "), _c('ul', {
    staticClass: "mdui-list"
  }, _vm._l((_vm.todos), function(todo, index) {
    return _c('li', {
      staticClass: "mdui-collapse-item"
    }, [_c('div', {
      staticClass: "mdui-collapse-item-header mdui-list-item mdui-ripple"
    }, [_c('label', {
      staticClass: "mdui-checkbox"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": todo.isFinished
      },
      on: {
        "click": function($event) {
          return _vm.toggleFinished(todo, index)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "mdui-checkbox-icon"
    })]), _vm._v(" "), (todo.isFinished == true) ? _c('div', {
      staticClass: "mdui-list-item-content todo-item"
    }, [_c('del', [_vm._v(_vm._s(todo.label))])]) : _c('div', {
      staticClass: "mdui-list-item-content todo-item"
    }, [_vm._v(_vm._s(todo.label))]), _vm._v(" "), _c('i', {
      staticClass: "mdui-collapse-item-arrow mdui-icon material-icons",
      staticStyle: {
        "font-size": "19px"
      },
      on: {
        "click": function($event) {
          return _vm.removeTodo(todo, index)
        }
      }
    }, [_vm._v("close")])]), _vm._v(" "), _c('ul', {
      staticClass: "mdui-collapse-item-body mdui-list mdui-list-dense"
    }, [_c('li', {
      staticClass: "mdui-list-item mdui-ripple todo-sub-list",
      on: {
        "click": function($event) {
          return _vm.removeTodo(todo, index)
        }
      }
    }, [_vm._v("删除")])])])
  }), 0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "mdui-textfield todo_input_wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTodo),
      expression: "newTodo"
    }],
    staticClass: "mdui-textfield-input",
    attrs: {
      "type": "text",
      "placeholder": "Add Todo"
    },
    domProps: {
      "value": (_vm.newTodo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addTodo($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTodo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "mdui-btn mdui-btn-icon mdui-ripple add_todo_button",
    on: {
      "click": _vm.addTodo
    }
  }, [_c('i', {
    staticClass: "mdui-icon material-icons mdui-list-item-icon"
  }, [_vm._v("send")])])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header mdui-color-blue mdui-col-xs-12 mdui-toolbar"
  }, [_c('div', [_vm._v("Opage")]), _vm._v(" "), _c('div', {
    staticClass: "mdui-toolbar-spacer"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-button"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/search/search.svg"),
      "width": "36px",
      "height": "36px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer mdui-card mdui-col-xs-12"
  }, [_c('ul', {
    staticClass: "social-buttons"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/viosey/O",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/footer/github.svg"),
      "alt": "",
      "width": "24px",
      "height": "24px;"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://yorkchou.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/footer/about.svg"),
      "alt": "",
      "width": "24px",
      "height": "24px;"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("\n        © 2025 "), _c('a', {
    attrs: {
      "href": "https://yorkchou.com",
      "target": "_blank"
    }
  }, [_vm._v("York Chou")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f6b36b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 114
// module chunks = 2